var _rect, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgBreak = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1015_7356",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1015_7356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.90005 20.9L1.60005 18.65C1.40005 18.45 1.30005 18.2167 1.30005 17.95C1.30005 17.6833 1.40005 17.45 1.60005 17.25C3.06672 15.6667 4.75838 14.4792 6.67505 13.6875C8.59172 12.8958 10.5334 12.5 12.5 12.5C14.4667 12.5 16.4042 12.8958 18.3125 13.6875C20.2209 14.4792 21.9167 15.6667 23.4 17.25C23.6 17.45 23.7 17.6833 23.7 17.95C23.7 18.2167 23.6 18.45 23.4 18.65L21.1 20.9C20.9167 21.0833 20.7042 21.1833 20.4625 21.2C20.2209 21.2167 20 21.15 19.8 21L16.9 18.8C16.7667 18.7 16.6667 18.5833 16.6 18.45C16.5334 18.3167 16.5 18.1667 16.5 18V15.15C15.8667 14.95 15.2167 14.7917 14.55 14.675C13.8834 14.5583 13.2 14.5 12.5 14.5C11.8 14.5 11.1167 14.5583 10.45 14.675C9.78338 14.7917 9.13338 14.95 8.50005 15.15V18C8.50005 18.1667 8.46672 18.3167 8.40005 18.45C8.33338 18.5833 8.23338 18.7 8.10005 18.8L5.20005 21C5.00005 21.15 4.77922 21.2167 4.53755 21.2C4.29588 21.1833 4.08338 21.0833 3.90005 20.9ZM6.50005 15.85C6.01672 16.1 5.55005 16.3875 5.10005 16.7125C4.65005 17.0375 4.18338 17.4 3.70005 17.8L4.70005 18.8L6.50005 17.4V15.85ZM18.5 15.9V17.4L20.3 18.8L21.3 17.85C20.8167 17.4167 20.35 17.0417 19.9 16.725C19.45 16.4083 18.9834 16.1333 18.5 15.9ZM11.5 7.5V2.5H13.5V7.5H11.5ZM18.1 10.35L16.7 8.9L20.25 5.35L21.65 6.8L18.1 10.35ZM6.90005 10.35L3.35005 6.8L4.75005 5.35L8.30005 8.9L6.90005 10.35Z",
    fill: "#757575"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBreak, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/break.53ec1013.svg";
export { ForwardRef as ReactComponent };